module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand2_m.d83d95226f8eef73993065f9a815291b.png";